import { Component, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { FocusableOption } from '@angular/cdk/a11y';
import { Suggestion } from '@emi/shared/models';

@Component({
  selector: 'via-search-suggestion',
  templateUrl: './search-suggestion.component.html',
  styleUrls: ['./search-suggestion.component.scss']
})
export class SearchSuggestionComponent implements FocusableOption {

  @Input()
  public suggestion = new Suggestion(0,'','','');

  @Output()
  public clickSuggestion = new EventEmitter<Suggestion>();

  @ViewChild('button')
  public button: ElementRef;

  public getSearchText() {
    this.clickSuggestion.emit(this.suggestion);
  }

  public focus(): void {
    this.button.nativeElement.focus();
  }

}
